const selectors = {
  image: '[data-comp-image-spinner-image]',
};

const masterTimelineOptions = {
  autoRemoveChildren: true
};

export {
  masterTimelineOptions,
  selectors
};
